module.exports = __webpack_public_path__ + "img/game features.a99976df.png";